var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.00028C16 12.0408 13.0049 15.3811 9.11411 15.9232C8.75031 15.9737 8.3781 16 8.00028 16C7.56417 16 7.1359 15.9652 6.71885 15.898C2.90929 15.2847 0 11.9819 0 8.00028C0 3.58196 3.58196 0 7.99972 0C12.4175 0 16 3.58196 16 8.00028Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11403 6.42384V8.16661H11.2699L10.9286 10.5142H9.11403V15.923C8.75023 15.9735 8.37802 15.9998 8.0002 15.9998C7.56409 15.9998 7.13582 15.9651 6.71877 15.8978V10.5142H4.73047V8.16661H6.71877V6.03425C6.71877 4.71134 7.79111 3.63843 9.11459 3.63843V3.63955C9.11852 3.63955 9.12188 3.63843 9.1258 3.63843H11.2705V5.66877H9.8691C9.45261 5.66877 9.11459 6.00678 9.11459 6.42328L9.11403 6.42384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCircle);
export default __webpack_public_path__ + "static/media/facebook-circle.9aba64030eb81012ef3d2c0350b41e4d.svg";
export { ForwardRef as ReactComponent };